import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setCities, setDispositionSubChoiceCities } from 'Store/Organization/Cities/CitiesAction';
import { GET_CITIES, GET_DISPOSITIONSUBCHOICECITIES } from 'Store/Organization/Cities/CitiesType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrganizationApiService from './OrganizationApiService';
import { IPayload } from 'Model/IPayload';


function* getCities(payload:any): any {

    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.Organization,
        endpoint : `organizations/dropdown/cities?stateId=${payload?.state}`,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));

        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCities(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* getDispositionSubChoiceCities(payload:any): any {
    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.Organization,
        endpoint : `organizations/dropdown/cities?stateId=${payload?.state}`,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));

        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setDispositionSubChoiceCities(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetCities() {
    yield takeEvery(GET_CITIES, getCities)
    yield takeEvery(GET_DISPOSITIONSUBCHOICECITIES, getDispositionSubChoiceCities)
}

export default function* combinedSaga() {
    yield all([
        watchGetCities()
    ])
}
